import NextImage, { ImageProps } from "next/image"
import { FC, useState } from "react"




interface IProps extends ImageProps {

}



const Image: FC<IProps> = ({ ...props }) => {
    const [hasError, setHasError] = useState(false)





    return (
        <NextImage
            {...props}
            onError={() => setHasError(true)}
            src={hasError ? "/images/fallback/broken-image.svg" : props.src}
            placeholder="blur"
            blurDataURL="/images/media/spinner.png"
            {...(hasError && {
                style: {
                    objectFit: "scale-down"
                }
            })}
        />
    )
}

export default Image